import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurableOption } from '@speedy/core';

@Pipe({
  name: 'selectedOptionLabel',
  standalone: true,
})
export class SelectedOptionLabelPipe implements PipeTransform {
  transform(value: string, attribute: ConfigurableOption): unknown {
    const selectedOption = attribute?.options?.find((o) => o.value_index === value);

    return selectedOption?.label ?? '';
  }
}
